import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'

import { teamApi } from '@/features/recruiter/api/team.api'

const QUERY_KEY = ['recruiter', 'team'] as const

export function useTeamQuery() {
  return useQuery({ queryKey: QUERY_KEY, queryFn: teamApi.list })
}

export function useInviteTeamMember() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: teamApi.invite,
    onSuccess: () => void queryClient.invalidateQueries({ queryKey: QUERY_KEY }),
  })
}

export function useActivateMember() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: teamApi.activate,
    onSuccess: () => void queryClient.invalidateQueries({ queryKey: QUERY_KEY }),
  })
}

export function useDeactivateMember() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: teamApi.deactivate,
    onSuccess: () => void queryClient.invalidateQueries({ queryKey: QUERY_KEY }),
  })
}
